import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { protectedRoutes, publicRoutes, baseRoutes } from "./routes/";
import { PrivateRoute, AuthRoute } from "./routes/route";

import PublicLayout from "./components/Public-Layout/";
import ProtectedLayout from "./components/Protected-Layout/";
import AuthLayout from "./components/Auth-Layout/";
import StatusPage from "./components/StatusPage";
import Loader from "./components/Loader"; // 👈 add loader
import "remixicon/fonts/remixicon.css";
import { getUserGUID } from "./common";
import { getTimezoneOffset, postUpdateProfile } from "./helper/backend-methods";
import { startConnection } from "./helper/signalr-service";

function App() {
  const [loading, setLoading] = useState(true);

  const updateCustomerTimezone = () => {
    const offset = getTimezoneOffset();
    const userInfo = localStorage.getItem("userinfo");

    if (!userInfo || userInfo === "{}") return;

    const user = JSON.parse(userInfo);
    if (user.Timezone === offset) return;

    postUpdateProfile({
      Timezone: offset,
      IsTimeZoneUpdate: true,
    }).then(({ data }) => {
      if (data?.Status) {
        user.Timezone = offset;
        localStorage.setItem("userinfo", JSON.stringify(user));
      }
    });
  };

  useEffect(() => {
    try {
      // appboy.initialize(process.env.REACT_APP_BRAZE_API_KEY, {
      //   baseUrl: process.env.REACT_APP_BRAZE_BASE_URL,
      //   enableLogging: false,
      //   allowUserSuppliedJavascript: false,
      // });

     // appboy.openSession();

      const userGUID = getUserGUID();
      if (userGUID) {
       // appboy.changeUser(userGUID);
        updateCustomerTimezone();
        startConnection();

        window.GlobalPayments?.configure({
          publicApiKey: process.env.REACT_APP_HEARTLAND_PUBLIC_KEY,
        });
      }
    } finally {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <Routes>
      {baseRoutes.map((route, idx) => (
        <Route
          key={`auth-${idx}`}
          path={route.path}
          element={
            <AuthRoute>
              <AuthLayout>
                <route.element />
              </AuthLayout>
            </AuthRoute>
          }
        />
      ))}

      {publicRoutes.map((route, idx) => (
        <Route
          key={`public-${idx}`}
          path={route.path}
          element={
            <PublicLayout hasHeader={route.header} hasFooter={route.footer}>
              <route.element />
            </PublicLayout>
          }
        />
      ))}

      {protectedRoutes.map((route, idx) => (
        <Route
          key={`protected-${idx}`}
          path={route.path}
          element={
            <PrivateRoute>
              <ProtectedLayout>
                <route.element />
              </ProtectedLayout>
            </PrivateRoute>
          }
        />
      ))}

      <Route
        path="*"
        element={
          <PublicLayout>
            <StatusPage status="404" />
          </PublicLayout>
        }
      />
    </Routes>
  );
}

export default App;
